import { FC } from 'react';
import { useSelector } from 'react-redux';

import clsx from 'clsx';
import { RoomPlace } from 'src/components/RoomPlace/RoomPlace';
import { getCurrentRoom, getFilteredRooms } from 'src/store/rooms/selectors';
import { getEmployeeNumber } from 'src/store/user/selectors';
import { BookingState, Room } from 'src/types';

import classes from './BookingRoomPlace.module.scss';

export interface BookingRoomPlaceProps {
  item: Room;
}

export const BookingRoomPlace: FC<BookingRoomPlaceProps> = ({ item }) => {
  const room = useSelector(getCurrentRoom);
  const filteredRooms = useSelector(getFilteredRooms);
  const employeeNumber = useSelector(getEmployeeNumber);

  let bookedByMe = false;
  let bookedByCollegue = false;

  if (item.status) {
    if (item.status.responsibleEmployeeNumber === employeeNumber) {
      bookedByMe = true;
    } else {
      bookedByCollegue = true;
    }
  }
  const disabled = !filteredRooms.has(item.mapPlaceId);

  const active = room?.mapPlaceId === item.mapPlaceId;

  const unavailable =
    bookedByCollegue ||
    item.status?.state === BookingState.BookingInProgress ||
    item.status?.state === BookingState.UnbookingInProgress;

  return (
    <RoomPlace
      item={item}
      className={clsx(
        classes.room,
        !disabled && classes.enabled,
        bookedByMe && classes.bookedByMe,
        unavailable && classes.unavailable,
        active && classes.active,
      )}
      contentClassName={clsx(
        classes.title,
        unavailable && classes.titleUnavailable,
        active && classes.titleActive,
      )}
      disabled={disabled}
    />
  );
};
